<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <div slot="header" class="card-header">
          <h4 class="card-title">
            Estoque
            <a
              style="font-size: 1em"
              class="btn btn-info btn-link btn-xs offset-sm-10"
              @click="filtro = true"
            >
              <i  class="nc-icon nc-zoom-split "></i>
            </a>
          </h4>
          <el-dialog center :visible.sync="filtro" title="Filtros">
            <card class="row">
              <div class="col-sm-12">
                <label class="col-sm-6">Produtos</label>
                <el-select
                  class="select-default col-sm-12"
                  size="large"
                  placeholder="Selecione"
                  v-model="produto"
                >
                  <el-option
                    v-for="option in products"
                    class="select-danger"
                    :value="option.id"
                    :label="option.name"
                    :key="option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-sm-12" style="margin-top: 10px">
                <label class="col-sm-6">Categoria</label>
                <el-select
                  class="select-default col-sm-12"
                  size="large"
                  placeholder="Selecione"
                  v-model="category"
                >
                  <el-option
                    v-for="tipo in categories"
                    class="select-danger"
                    :value="tipo.id"
                    :label="tipo.name"
                    :key="tipo.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-sm-12" style="margin-top: 10px">
                <label class="col-sm-6">Maquina</label>
                <el-select
                  class="select-default col-sm-12"
                  size="large"
                  placeholder="Selecione"
                  v-model="vendMachine"
                >
                  <el-option
                    v-for="maq in machine"
                    class="select-danger"
                    :value="maq.id"
                    :label="maq.location"
                    :key="maq.id"
                  ></el-option>
                </el-select>
              </div>
            </card>
            <button class="btn btn-danger offset-sm-8" @click="clearFiltro()">Limpar</button>&nbsp;
            <button class="btn btn-success" @click="filtragem()">Filtrar</button>
          </el-dialog>
          <!-- <router-link to="/app/products/category">
            <l-button wide type="primary" round>
              <span class="btn-label">
                <i class="fa fa-plus"></i>
              </span>
              Criar
            </l-button>
          </router-link>-->
          <!-- <p class="card-category">Here is a subtitle for this table</p> -->
        </div>
        <!-- <div class="x-page-links">
          <el-input
            v-model="search"
            prefix-icon="el-icon-search"
            style="width: 250px"
            placeholder="Digite para pesquisar"/>
        </div> -->
        <div class="table-responsive table-full-width">
          <el-table class="table-striped" :data="tableData" @sort-change="sorting" v-loading="loading" >
            <el-table-column label="VM" prop="vm_location" width="120" sortable="custom"/>
            <el-table-column label="Mola" prop="vm_position" width="80" />
            <el-table-column label="Produto" min-width="190" prop="product_name" sortable="custom"/>
            <el-table-column label="Variação" prop="product_variant_name" min-width="130"/>
            <el-table-column prop="amount" label="Quantidade" width="130" sortable="custom"></el-table-column>
            <el-table-column prop="capacity" label="Capacidade" width="130" sortable="custom"></el-table-column>
            <el-table-column prop="expiration_date" label="Data de Validade" width="160" sortable="custom"></el-table-column>          </el-table>
          <p class="x-page-links">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-sizes="[10, 15, 20,25]"
              :page-size="100"
              layout="sizes, prev, pager, next"
              :total="totalResults">
            </el-pagination>
          </p>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Dialog, Select, Option, Input, Pagination, Loading} from "element-ui";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [Dialog.name]: Dialog,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      filtro: false,
      loading: true,
      totalResults: 30,
      pesquisa: '',
      page: 1,
      pageSize: 10,
      order: false,
      search: '',
      sord: '',
      produto: [],
      vendMachine: [],
      stock: [],
      stockAPI: [],
      category: [],
      coils: [],
      ciaID: ''
    };
  },
  computed: {
    tableData() {
      const stock = this.stock;
      console.log('stokec', this.stock)
      const populated = stock.map(v => {
        let expiration_date

        if (v.expiration_date) {
          expiration_date = this.formatDate(v.expiration_date);
        }

        return {...v, expiration_date}
      })
      console.log('pop', populated)
      return populated
    },
    showItem() {
      const imach = localStorage.getItem("imach")
      if (imach === 'true') {
        return true
      } else {
        return false
      }
    },
    products() {
      return this.$store.state.products.products;
    },
    shelves() {
      return this.$store.state.shelves.shelves;
    },
    variants() {
      return this.$store.state.products.variants.variants;
    },
    machine() {
      var seenLocation = {};

      var fil = this.$store.state.machines.machines.filter(function(
        currentObject
      ) {
        if (currentObject.location in seenLocation) {
          return false;
        } else {
          seenLocation[currentObject.location] = true;
          return true;
        }
      });
      return fil;
    },
    categories() {
      return this.$store.state.categories.categories;
    }
  },
  created() {
    var ciaID = localStorage.getItem('imachCiaID')
    this.ciaID = ciaID
    if (ciaID) { 
      this.getData(ciaID)
    } else {
      this.getData()
    }
  },
  mounted () {
  },
  methods: {
    handleEdit(i, row) {
      console.log(row);
      this.$router.push(`/app/machines/stock/${row.id}`);
    },
    formatDate (date) {
      if (!date) return null
      if (date === null) {
        return ''
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    filtragem() {
      this.pesquisa = ''
      if (
        this.produto !== "" &&
        this.category === "" &&
        this.vendMachine === ""
      ) {
        this.pesquisa = "&product=" + this.produto;
      }
      if (
        this.category !== "" &&
        this.produto === "" &&
        this.vendMachine === ""
      ) {
        this.pesquisa = "&product__category=" + this.category;
      }
      if (
        this.vendMachine !== "" &&
        this.category === "" &&
        this.produto === ""
      ) {
        this.pesquisa = "&shelf__vm=" + this.vendMachine;
      }
      if (
        this.produto !== "" &&
        this.category !== "" &&
        this.vendMachine === ""
      ) {
        this.pesquisa =
          "&product=" + this.produto + "&product__category=" + this.category;
      }
      if (
        this.produto !== "" &&
        this.category === "" &&
        this.vendMachine !== ""
      ) {
        this.pesquisa =
          "&product=" + this.produto + "&shelf__vm=" + this.vendMachine;
      }
      if (
        this.produto === "" &&
        this.category !== "" &&
        this.vendMachine !== ""
      ) {
        this.pesquisa =
          "&product__category=" +
          this.category +
          "&shelf__vm=" +
          this.vendMachine;
      }
      if (
        this.produto !== "" &&
        this.category !== "" &&
        this.vendMachine !== ""
      ) {
        this.pesquisa =
          "&product=" +
          this.produto +
          "&product__category=" +
          this.category +
          "&shelf__vm=" +
          this.vendMachine;
      }
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.getData(ciaID)
      } else {
        this.getData()
      }
      this.loading = true
      this.filtro = false;
    },
    clearFiltro() {
      this.produto = ""
      this.category = ""
      this.vendMachine = ""
      this.pesquisa = ''
      this.filtro = false
      this.page = 1
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    getData(ciaID) {
      if (ciaID) {
        ciaID = ciaID
      } else {
        ciaID = ''
      }
      this.loading = true
      this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID}).then(() => {
        this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID}).then(() => {
          this.$store.dispatch("stock/listSort", {sort: '?page_size=' 
            + this.pageSize + '&active=true' + '&company=' + ciaID  
            + '&page=' + this.page + '&ordering=' + this.sord + this.pesquisa}).then(resp => {
              this.totalResults = this.$store.state.stock.page.count
              this.stock = resp
              this.stockAPI = resp
              this.loading = false
              console.log('total', this.totalResults)
              console.log('store', this.$store.state)
            }).catch(err => console.log(err));
        });
      });
      this.$store.dispatch("machines/listSort",{sort: '?company=' + ciaID}).catch(err => console.log(err));
      this.$store.dispatch("categories/listSort",{sort: '?company=' + ciaID}).catch(err => console.log(err));
      this.$store.dispatch("shelves/listSort",{sort: '?company=' + ciaID}).catch(err => console.log(err));
    },
    sorting(x) {
      this.loading = true
      var sinal
      console.log('x',x)
      if (x.order === 'descending') {
        sinal = '-'
      } else {
        sinal = ''
      }
      if (x.prop === 'vm_location') {
        x.prop = 'shelf__vm__location'
      }
      if (x.prop === 'product_name') {
        x.prop = 'product'
      }
      this.sord = sinal + x.prop
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleSizeChange(val) {
      this.loading = true
      this.pageSize = val
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
    handleCurrentChange(val) {
      this.loading = true
      this.page = val
      var ciaID = localStorage.getItem('imachCiaID')
      if (ciaID) { 
        this.getData(ciaID)
      } else {
        this.getData()
      }
    },
  }
};
</script>
<style scoped>
.td-actions > a {
  margin-bottom: 0;
  padding: 0px 16px;
}
/* .card-header {
  display: flex;
}
.card-header a {
  margin-left: auto;
} */
.x-page-links {
  margin-top: 15px;
  text-align: center;
}
.x-page-links span {
  cursor: pointer;
  margin: 0 10px;
}
</style>
